import React from 'react';
import Map from './Map';
import { useJsApiLoader } from '@react-google-maps/api';
import MetaTags from './MetaTags';

/**
 * BodyLocations component for Portuguese locale
 * Displays Google Maps with Hertz 24/7 locations
 */
function BodyLocations() {

    
    const strGMK = window._env_?.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    
    const { isLoaded, loadError } = useJsApiLoader({
        id: strGMK || 'fallback',
        googleMapsApiKey: strGMK || ''
    });
    
    if (!strGMK) {
        return (
          <div className="container-fluid body-font">
            <div className="alert alert-warning" role="alert">
              <strong>Mapa indisponível</strong> - Configuração em falta. Entre em contacto com o suporte.
            </div>
          </div>
        );
    }
    
    if (loadError) {
        return (
          <div className="container-fluid body-font">
            <div className="alert alert-danger" role="alert">
              <strong>Mapa indisponível</strong> - Falha ao carregar o Google Maps. Tente novamente mais tarde.
            </div>
          </div>
        );
    }

    return (<>
        <MetaTags
            title='Localização lojas parceiras - Hertz 24/7®'
            description='Encontre-nos nas lojas parceiras lojas IKEA, Leroy Merlin e Brico Depôt. Alugar uma carrinha à hora Hertz 24/7® é simples.'
        />
        <div className="container-fluid body-font">
            <div className="row">
                <div className="col-xs-12 col-md-6 py-md-5">
                    <p className="h6"><b>Sempre por perto</b></p>
                    <p className="h1"><b>Localizações</b></p>
                    <p>Escolha a loja mais perto de si no seguinte mapa.</p>
                    
                </div>
            </div>
            <Map isLoaded={isLoaded}/>
            <div className="row">
                <div className="col-xs-12 py-md-5" style={{ textAlign: 'left' }}>
                    <h2 className="display-5"><b>As nossas localizações</b></h2>
                    <p>Com lojas de norte a sul do país, a Hertz 24/7 está mais perto do que pensa. Encontre-nos nas lojas participantes IKEA, Leroy Merlin, Brico Depôt e Allmat.</p>
                    <div className="row">
                        <div className="col-xs-12 col-md-4 " style={{ textAlign: 'left' }}>
                            <p><b>Reino Unido (300 Localizações)</b></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-gb13121600020009&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Manchester</a></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-gb11082902024006&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>London</a></p>
                        </div>
                        <div className="col-xs-12 col-md-4 " style={{ textAlign: 'left' }}>
                            <p><b>França (20 Localizações)</b></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-fr19100400001005&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Paris</a></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-fr19110500007004&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Marseilles</a></p>
                        </div>
                        <div className="col-xs-12 col-md-4 " style={{ textAlign: 'left' }}>
                            <p><b>Alemanha (280 Localizações)</b></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-de18112800001004&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Berlin</a></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-de15102900001000&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Frankfurt</a></p>
                        </div>
                        <div className="col-xs-12 col-md-4 " style={{ textAlign: 'left' }}>
                            <p><b>Itália (75 Localizações)</b></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-it17072800007000&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Rome</a></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-it17072800005002&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Milan</a></p>
                        </div>
                        <div className="col-xs-12 col-md-4 " style={{ textAlign: 'left' }}>
                            <p><b>Portugal (39 Localizações)</b></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-pt21051200001008&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Lisbon</a></p>
                            <p><a href='https://booking.hertz247.com/booking/book?location=prk-pt17062200003001&product=HOURLY_RENTAL' style={{textDecoration:'none'}}>Porto</a></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row shadow-lg p-3 mb-5 bg-body rounded" >
                <a href='https:/l.ead.me/beWm77'><img className="img-fluid rounded-4" src="https://images.hertz.com/content/dam/hod/images/en-gb/static/LocationBannerPT.png" alt='' style={{ width: '100vw', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} /></a>
            </div> 
        </div>
    </>
    );
}
export default BodyLocations;